// extracted by mini-css-extract-plugin
module.exports = {"table":"Client_table_30YmA","sortable":"Client_sortable_pJAaM","checkbox":"Client_checkbox_2krmy","selectable":"Client_selectable_3NYta"};